<script setup>
import Header    from '@pages/home/components/Header.vue'
import Slider    from '@pages/home/components/Slider.vue'
import Statistics from '@pages/home/components/Statistics.vue'
import Features  from '@pages/home/components/Features.vue'
import Footer    from '@pages/home/components/Footer.vue'
import { Link } from '@inertiajs/vue3'
</script>

<template>
  <div class="min-h-screen bg-background text-gray-800">
    <Header />
    <Slider />

    <!-- WELCOME -->
    <section class="py-20 px-6 bg-white">
      <div class="max-w-3xl mx-auto text-center">
        <h2 class="text-3xl md:text-4xl font-bold text-primary mb-6">
          Welcome to Bn Mas'ud College
        </h2>
        <p class="text-lg text-gray-600 leading-relaxed mb-8">
          Bn Mas'ud College nurtures righteous scholars through Qur'anic memorization,
          sound Islamic knowledge, and disciplined character. Our approach blends
          traditional scholarship with structured education, preparing students
          to serve the Ummah with wisdom and integrity.
        </p>
        <Link href="/register" class="px-10 py-3 bg-green-600 hover:bg-green-700 rounded-full font-semibold text-white transition">
          Apply Now
        </Link>
      </div>
    </section>

    <Statistics />
    <Features />
    <Footer />
  </div>
</template>